/** The permissions that P0's connector checks the app's installation for, as
 * GitHub's app registration names them. They match the connector's
 * `REQUIRED_PERMISSIONS` in p0-connector-github-repositories. */
const APP_PERMISSIONS = {
  administration: "write",
  members: "read",
  metadata: "read",
  organization_custom_roles: "read",
} as const;

// GitHub refuses an app name over 34 characters. The org's part is what's
// cut, so every name says what the app is for.
const APP_NAME_PREFIX = "P0 repo access ";
const APP_NAME_MAX_LENGTH = 34;

/** The URL of `org`'s GitHub Apps, where the app's settings page is listed. */
export const toOrgAppsUrl = (org: string) =>
  `https://github.com/organizations/${encodeURIComponent(org)}/settings/apps`;

/**
 * The URL that opens GitHub's form to register P0's repository access app in
 * `org`, filled in through URL parameters as github-ai-frontend fills in its
 * app: the permissions above, no webhook and so no events, and installable
 * only in `org`.
 *
 * GitHub app names are unique across GitHub, so GitHub may ask the customer
 * for another one. Any name works.
 *
 * @param org The organization's login, already checked against
 * `GITHUB_ORG_PATTERN`
 */
export const toAppCreationUrl = (org: string) =>
  `${toOrgAppsUrl(org)}/new?${new URLSearchParams({
    name: `${APP_NAME_PREFIX}${org}`.slice(0, APP_NAME_MAX_LENGTH),
    url: "https://p0.dev",
    description:
      "App used by P0 to grant access to your GitHub organization's repositories",
    public: "false",
    ...APP_PERMISSIONS,
    webhook_active: "false",
  }).toString()}`;
